import request from '@/utils/request'

export const verificationsPost = (options = {}) => request({
    url: '/quiz_apis/verifications',
    method: 'post',
    ...options
})

export const userLoginPost = (options = {}) => request({
    url: '/quiz_apis/user/login',
    method: 'post',
    ...options
})

export const userUidGet = (options = {}) => request({
    url: '/quiz_apis/user/{uid}',
    method: 'get',
    ...options
})

export const userUidPut = (options = {}) => request({
    url: '/quiz_apis/user/{uid}',
    method: 'put',
    ...options
})
export const schoolsGet = (options = {}) => request({
    url: '/quiz_apis/schools',
    method: 'get',
    ...options
})